import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import I18N from "@/data/i18n";

const LanguageContext = createContext({ lang: "en", t: I18N.en });

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const lang = location.pathname.startsWith("/zn") ? "zh" : "en";
  const value = useMemo(() => ({ lang, t: I18N[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
